<template>
  <layout class="payment-list-page-container">
    <div class="w-full adm-container flex justify-end text-primary font-bold sm:mb-4 lg:mb-0">
      <download-csv
        :download-url="csvUrl"
        file-name="Payment Statements"
      />
    </div>
    <div class="w-full flex flex-col adm-container">
      <div class="bg-grey-lighter p-4 border rounded-tl rounded-tr flex h-32 items-center">
        <img
          src="../../../../assets/images/pathao_logo_black.png"
          style="height: 40px"
        >
        <div class="flex-1 items-end flex flex-col">
          <h4 class="uppercase text-grey-darker text-xs font-semibold">Total Payments</h4>
          <h1 class="uppercase text-primary">{{ totalPayment }}</h1>
        </div>
      </div>
      <div class="border-l border-r border-b rounded-br rounded-bl bg-white flex-col">
        <div class="p-4 flex w-full h-32">
          <div class="flex-1 flex flex-col justify-center">
            <h4 class="w-full uppercase text-grey-darker text-xs font-semibold">Partner Name</h4>
            <h2 class="w-full">{{ user.name || '-' }}</h2>
          </div>
          <div class="flex-1 lg:flex sm:hidden flex-col lg:justify-center sm:justify-left">
            <pt-form-input
              v-model="searchKey"
              type="text"
              icon-class="fa-search"
              icon-position="left"
              placeholder="Search by driver name or number"
            />
          </div>
          <div class="flex-1 flex flex-col items-end justify-center">
            <h4 class="w-full uppercase text-grey-darker lg:text-right text-xs font-semibold">Period Ending</h4>
            <h2 class="w-full lg:text-right">{{ $route.params.endDate }}</h2>
          </div>
        </div>
        <div class="px-4  w-full sm:flex lg:hidden">
          <div class="flex-1 justify-center">
            <pt-form-input
              v-model="searchKey"
              type="text"
              icon-class="fa-search"
              icon-position="left"
              placeholder="Search by driver name or number"
              class="sm:w-full"
            />
          </div>
        </div>
        <div class="table-loader-container relative">
          <pt-list
            class="overflow-scroll rounded-none border-l-0 border-r-0"
          >
            <div
              class="p-4 bg-grey-lighter border-b flex-row font-bold sm:hidden lg:flex"
              style="width: 1772px"
            >
              <div style="min-width: 180px">
                <span class="font-bold">Driver</span>
              </div>
              <div style="min-width: 120px; text-align: left">
                <span class="font-bold">Phone</span>
              </div>
              <div style="min-width: 120px; text-align: right">
                <span class="font-bold">Regular Fare</span>
              </div>
              <div style="min-width: 120px; text-align: right">
                <span class="font-bold">Surge</span>
              </div>
              <div style="min-width: 120px; text-align: right">
                <span class="font-bold">Pathao Fee</span>
              </div>
              <div style="min-width: 120px; text-align: right">
                <span class="font-bold">Net Fare</span>
              </div>
              <div style="min-width: 120px; text-align: right">
                <span class="font-bold">Boost</span>
              </div>
              <div style="min-width: 120px; text-align: right">
                <span class="font-bold">Quest</span>
              </div>
              <div style="min-width: 120px; text-align: right">
                <span class="font-bold">Referral</span>
              </div>
              <div style="min-width: 120px; text-align: right">
                <span class="font-bold">Cancellation</span>
              </div>
              <div style="min-width: 120px; text-align: right">
                <span class="font-bold">Fare Adjustments</span>
              </div>
              <div style="min-width: 120px; text-align: right">
                <span class="font-bold">Cash Collected</span>
              </div>
              <div style="min-width: 120px; text-align: right">
                <span class="font-bold">Digital Payment</span>
              </div>
              <div style="min-width: 120px; text-align: right">
                <span class="font-bold">Net Payout</span>
              </div>
            </div>
            <pt-list-item
              v-for="(row, rowIndex) in filteredList"
              :key="rowIndex"
              style="width: 1772px"
            >
              <div class="flex flex-1 sm:flex-col lg:flex-row">
                <div style="min-width: 180px">
                  <span class="font-bold lg:hidden sm:mr-2 lg:mr-0">Driver:</span>
                  <router-link
                    :to="`/captain-management/payment-statements/driver-trips/${row.driver_id}/start/${$route.params.startDate}/end/${$route.params.endDate}`"
                    class="no-underline text-black font-bold"
                  >{{ row.name }}</router-link>
                </div>
                <div
                  class="text-left"
                  style="min-width: 120px">
                  <span class="font-bold lg:hidden sm:mr-2 lg:mr-0">Phone:</span>
                  <span>{{ row.phone }}</span>
                </div>
                <div
                  class="sm:text-left lg:text-right"
                  style="min-width: 120px">
                  <span class="font-bold lg:hidden sm:mr-2 lg:mr-0">Regular Fare:</span>
                  <span>{{ CurrencyConverter(row.regular_fare) }}</span>
                </div>
                <div
                  class="sm:text-left lg:text-right"
                  style="min-width: 120px">
                  <span class="font-bold lg:hidden sm:mr-2 lg:mr-0">Surge:</span>
                  <span>{{ CurrencyConverter(row.surge) }}</span>
                </div>
                <div
                  class="sm:text-left lg:text-right"
                  style="min-width: 120px">
                  <span class="font-bold lg:hidden sm:mr-2 lg:mr-0">Pathao Fee:</span>
                  <span>{{ CurrencyConverter(row.pathao_fee) }}</span>
                </div>
                <div
                  class="sm:text-left lg:text-right"
                  style="min-width: 120px">
                  <span class="font-bold lg:hidden sm:mr-2 lg:mr-0">Net Fare:</span>
                  <span>{{ CurrencyConverter(row.net_fare) }}</span>
                </div>
                <div
                  class="sm:text-left lg:text-right"
                  style="min-width: 120px">
                  <span class="font-bold lg:hidden sm:mr-2 lg:mr-0">Boost:</span>
                  <span>{{ CurrencyConverter(row.boost) }}</span>
                </div>
                <div
                  class="sm:text-left lg:text-right"
                  style="min-width: 120px">
                  <span class="font-bold lg:hidden sm:mr-2 lg:mr-0">Quest:</span>
                  <span>{{ CurrencyConverter(row.quest) }}</span>
                </div>
                <div
                  class="sm:text-left lg:text-right"
                  style="min-width: 120px">
                  <span class="font-bold lg:hidden sm:mr-2 lg:mr-0">Referral:</span>
                  <span>{{ CurrencyConverter(row.referral) }}</span>
                </div>
                <div
                  class="sm:text-left lg:text-right"
                  style="min-width: 120px">
                  <span class="font-bold lg:hidden sm:mr-2 lg:mr-0">Cancellation:</span>
                  <span>{{ CurrencyConverter(row.cancelation) }}</span>
                </div>
                <div
                  class="sm:text-left lg:text-right"
                  style="min-width: 120px">
                  <span class="font-bold lg:hidden sm:mr-2 lg:mr-0">Fare Adjustments:</span>
                  <span>{{ CurrencyConverter(row.fare_adjustment) }}</span>
                </div>
                <div
                  class="sm:text-left lg:text-right"
                  style="min-width: 120px">
                  <span class="font-bold lg:hidden sm:mr-2 lg:mr-0">Cash Collected:</span>
                  <span>{{ CurrencyConverter(row.cash_collected) }}</span>
                </div>
                <div
                  class="sm:text-left lg:text-right"
                  style="min-width: 120px">
                  <span class="font-bold lg:hidden sm:mr-2 lg:mr-0">Digital Payment:</span>
                  <span>{{ CurrencyConverter(row.wallet_payment) }}</span>
                </div>
                <div
                  class="sm:text-left lg:text-right"
                  style="min-width: 120px">
                  <span class="font-bold lg:hidden sm:mr-2 lg:mr-0">Net Payout:</span>
                  <span>{{ CurrencyConverter(row.net_payout) }}</span>
                </div>
              </div>
            </pt-list-item>
          </pt-list>

          <table-placeholder
            :is-syncing="tableLoader"
            :data-length="filteredList.length"
            loader-class="text-black"
          />
        </div>
      </div>
    </div>
  </layout>
</template>

<script>
import isNumber from 'lodash/isNumber';
import iterate from 'lodash/each';
import { PtPagination } from '@pathao/ui-components/esm/Pagination';
import { PtList, PtListItem } from '@pathao/ui-components/esm/List';
import { PtFormInput } from '@pathao/ui-components/esm/FormComponents';
import Layout from '@layouts/main';
import TablePlaceholder from '../../../../components/custom/TablePlaceholder/';
import DownloadCsv from '../../../../components/custom/DownloadCsv/';
import makeRequest from '../../../../utils/apiRequest';
import SelectedDates from '../../../../utils/selected-dates';
import CurrencyConverter from '../../../../plugins/CurrencyConverter';
import Config from '../../../../config/index';
import cloneArray from 'lodash/clone';

export default {
  name: 'PaymentInvoice',
  page: {
    title: 'Invoice',
  },
  components: { PtPagination, Layout, TablePlaceholder, PtList, PtListItem, DownloadCsv, PtFormInput },
  mixins: [ CurrencyConverter ],
  props: {
    user: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      totalPayment: null,
      list: [],
      tableLoader: false,
      searchKey: '',
    };
  },
  computed: {
    csvUrl() {
      const selectedDates = SelectedDates({
        from: this.$route.params.startDate,
        to: this.$route.params.endDate,
      });

      return `${Config.api.baseURL}api/partners/driver-payment-statements/list/export?filterByStartDate=${selectedDates.filterByStartDate}&filterByEndDate=${selectedDates.filterByEndDate}`;
    },
    filteredList() {
      if (!this.searchKey) {
        return cloneArray(this.list);
      }

      let lowerKey = this.searchKey.replace(/[^\w\s]/gi, '');
      lowerKey = lowerKey.toLowerCase();
      lowerKey = lowerKey.trim();

      const filtered = this.list.filter((aList) => {
        let name = aList.name.replace(/[^\w\s]/gi, '');
        name = name.toLowerCase();
        name = name.trim();

        let phone = aList.phone.replace(/[^\w\s]/gi, '');
        phone = phone.trim();

        return name.indexOf(lowerKey) > -1 || phone.indexOf(lowerKey) > -1;
      });

      return cloneArray(filtered);
    },
  },
  mounted() {
    this.fetchInvoice();
  },
  methods: {
    fetchInvoice() {
      if (!this.$route.params.startDate || !this.$route.params.endDate) {
        return;
      }

      const paymentMeta = {
        url: `${Config.api.baseURL}api/partners/driver-payment-statements/list?filterByStartDate=${this.$route.params.startDate}&filterByEndDate=${this.$route.params.endDate}`,
      };

      this.tableLoader = true;

      makeRequest(paymentMeta)
        .then((response) => {
          this.list = response.data.data;
          this.tableLoader = false;
          this.totalPayment = this.getTotalPayment();
        })
        .catch((errorResponse) => {
          this.tableLoader = false;
          this.$notification.error('Error in getting requested invoice. Please try again');
          console.error(errorResponse);
        });
    },
    getTotalPayment() {
      let sum = 0;
      iterate(this.list, (row) => {
        if (isNumber(row.net_payout)) {
          sum += row.net_payout;
        }
      });

      sum = Math.round(sum * 100) / 100;

      return this.CurrencyConverter(sum);
    },
  },
};
</script>
